<template>
	<div v-if="context.menuItems && context.menuItems.length">
		<template v-if="context.title !== null">
			<nk-title size="lg">
				{{ context.title || 'Menü' }}
			</nk-title>
			<hr />
		</template>
		<nk-drilldown :menu-items="context.menuItems" />
	</div>
</template>

<script>
import TemplatesDefault from '../../mixins/templates-default';

/**
 * @prop {object} context
 * @prop {string} context.title
 * @prop {array} context.menuItems
 */
export default {
	name: 'NkSidebarSubmenu',

	mixins: [TemplatesDefault],
};
</script>
